/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../../../../components/Layout/DashboardLayout";
import { useSelector } from "react-redux";
import style from "./index.module.scss";
import { css } from "@emotion/react";
import { Pagination } from "../../../../components/Pagination";
import { ScaleLoader } from "react-spinners";
import {
  DateDropDown,
  DropDown,
  DurationDropDown,
  SmsDropDown,
  SmsStatus,
  ToolTip,
} from "../Filters";
import Button from "../../../../components/Button";
import dayjs from "dayjs";
import { useRef } from "react";
import { CSVLink } from "react-csv";
import Dialog from "../../../../components/Dialog";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { useClickOutside } from "../../../../hooks/useClickOutside";

export const Card = ({ logsMetrics }) => {
  const cards = [
    {
      description: "Processed SMS",
      num: `${logsMetrics ? logsMetrics.processed : "0"}`,
    },
    {
      description: "Total Cost Of Campagin",
      num: `NGN ${logsMetrics ? logsMetrics.totalCost : "0"}`,
    },
    {
      description: "Yet to deliver",
      num: `${logsMetrics ? logsMetrics.failed : "0"}`,
    },
    {
      description: "Success rate",
      num: `${logsMetrics ? logsMetrics.successRate : "0"}%`,
    },
  ];
  return (
    <div>
      <ul className={style["cards--container"]}>
        {cards.map((item, index) => (
          <li className={style["cards--item"]} key={index}>
            <header>
              <div className={style["metrics"]}>
                <h2>{item.num}</h2>
                <span
                  className={
                    index === 3 ? style["icon-success"] : style["icon"]
                  }
                >
                  {index === 0 ? (
                    <svg
                      class="svg-icon"
                      width="20"
                      height="20"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        style={{ fill: "#990006" }}
                        d="M853.333333 85.333333H170.666667C123.52 85.333333 85.76 123.52 85.76 170.666667L85.333333 938.666667l170.666667-170.666667h597.333333c47.146667 0 85.333333-38.186667 85.333334-85.333333V170.666667c0-47.146667-38.186667-85.333333-85.333334-85.333334zM554.666667 597.333333h-85.333334v-85.333333h85.333334v85.333333z m0-170.666666h-85.333334v-170.666667h85.333334v170.666667z"
                      />
                    </svg>
                  ) : index === 1 ? (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        style={{ fill: "#990006" }}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.9999 19.5999C12.546 19.5999 14.9878 18.5885 16.7881 16.7881C18.5885 14.9878 19.5999 12.546 19.5999 9.9999C19.5999 7.45382 18.5885 5.01203 16.7881 3.21168C14.9878 1.41133 12.546 0.399902 9.9999 0.399902C7.45382 0.399902 5.01203 1.41133 3.21168 3.21168C1.41133 5.01203 0.399902 7.45382 0.399902 9.9999C0.399902 12.546 1.41133 14.9878 3.21168 16.7881C5.01203 18.5885 7.45382 19.5999 9.9999 19.5999ZM11.1999 3.9999C11.1999 3.68164 11.0735 3.37642 10.8484 3.15137C10.6234 2.92633 10.3182 2.7999 9.9999 2.7999C9.68164 2.7999 9.37642 2.92633 9.15137 3.15137C8.92633 3.37642 8.7999 3.68164 8.7999 3.9999V4.1103C8.08311 4.2379 7.39921 4.50803 6.7887 4.9047C5.9223 5.4807 5.1999 6.4107 5.1999 7.5999C5.1999 8.7879 5.9223 9.7179 6.7887 10.2951C7.3647 10.6791 8.0535 10.9491 8.7999 11.0895V13.4187C8.3307 13.2663 7.9839 13.0383 7.7883 12.8139C7.68678 12.6893 7.56128 12.5864 7.41924 12.5113C7.27719 12.4361 7.1215 12.3903 6.9614 12.3764C6.80129 12.3626 6.64004 12.381 6.48721 12.4307C6.33438 12.4804 6.19308 12.5602 6.07169 12.6655C5.9503 12.7708 5.85131 12.8995 5.78057 13.0438C5.70984 13.188 5.6688 13.3451 5.6599 13.5055C5.65101 13.666 5.67443 13.8266 5.72878 13.9778C5.78313 14.129 5.8673 14.2678 5.9763 14.3859C6.6507 15.1647 7.6719 15.6771 8.7999 15.8895V15.9999C8.7999 16.3182 8.92633 16.6234 9.15137 16.8484C9.37642 17.0735 9.68164 17.1999 9.9999 17.1999C10.3182 17.1999 10.6234 17.0735 10.8484 16.8484C11.0735 16.6234 11.1999 16.3182 11.1999 15.9999V15.8895C11.9167 15.7619 12.6006 15.4918 13.2111 15.0951C14.0775 14.5191 14.7999 13.5891 14.7999 12.3999C14.7999 11.2119 14.0775 10.2819 13.2111 9.7047C12.6006 9.30803 11.9167 9.0379 11.1999 8.9103V6.5811C11.6691 6.7335 12.0159 6.9615 12.2115 7.1859C12.314 7.30748 12.4396 7.40748 12.581 7.48009C12.7225 7.55271 12.8769 7.59649 13.0354 7.6089C13.1939 7.6213 13.3533 7.60209 13.5044 7.55236C13.6554 7.50264 13.795 7.4234 13.9151 7.31924C14.0353 7.21509 14.1335 7.0881 14.2042 6.94566C14.2748 6.80322 14.3164 6.64815 14.3266 6.48949C14.3368 6.33082 14.3154 6.17171 14.2635 6.02139C14.2117 5.87108 14.1305 5.73257 14.0247 5.6139C13.3491 4.8351 12.3291 4.3227 11.1999 4.1103V3.9999Z"
                        fill="#990006"
                        fillOpacity="0.8"
                      />
                    </svg>
                  ) : index === 2 ? (
                    <svg
                      class="svg-icon"
                      width="24"
                      height="18"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        style={{ fill: "#990006" }}
                        d="M853.333333 85.333333H170.666667C123.52 85.333333 85.76 123.52 85.76 170.666667L85.333333 938.666667l170.666667-170.666667h597.333333c47.146667 0 85.333333-38.186667 85.333334-85.333333V170.666667c0-47.146667-38.186667-85.333333-85.333334-85.333334zM384 469.333333h-85.333333v-85.333333h85.333333v85.333333z m170.666667 0h-85.333334v-85.333333h85.333334v85.333333z m170.666666 0h-85.333333v-85.333333h85.333333v85.333333z"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="24"
                      height="18"
                      viewBox="0 0 24 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        style={{
                          fill: "#02A287",
                          padding: "2rem",
                          background: "gree",
                        }}
                        d="M10.5 18C10.5 18 9 18 9 16.5C9 15 10.5 10.5 16.5 10.5C22.5 10.5 24 15 24 16.5C24 18 22.5 18 22.5 18H10.5ZM16.5 9C17.6935 9 18.8381 8.52589 19.682 7.68198C20.5259 6.83807 21 5.69347 21 4.5C21 3.30653 20.5259 2.16193 19.682 1.31802C18.8381 0.474106 17.6935 0 16.5 0C15.3065 0 14.1619 0.474106 13.318 1.31802C12.4741 2.16193 12 3.30653 12 4.5C12 5.69347 12.4741 6.83807 13.318 7.68198C14.1619 8.52589 15.3065 9 16.5 9Z"
                        fill="#750005"
                        fillOpacity="0.8"
                      />
                      <path
                        style={{ fill: "#02A287" }}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.824 17.9999C7.60163 17.5316 7.49073 17.0182 7.5 16.4999C7.5 14.4674 8.52 12.3749 10.404 10.9199C9.46364 10.6302 8.48392 10.4885 7.5 10.4999C1.5 10.4999 0 14.9999 0 16.4999C0 17.9999 1.5 17.9999 1.5 17.9999H7.824Z"
                        fill="#750005"
                        fillOpacity="0.8"
                      />
                      <path
                        style={{ fill: "#02A287" }}
                        d="M6.75 9C7.74456 9 8.69839 8.60491 9.40165 7.90165C10.1049 7.19839 10.5 6.24456 10.5 5.25C10.5 4.25544 10.1049 3.30161 9.40165 2.59835C8.69839 1.89509 7.74456 1.5 6.75 1.5C5.75544 1.5 4.80161 1.89509 4.09835 2.59835C3.39509 3.30161 3 4.25544 3 5.25C3 6.24456 3.39509 7.19839 4.09835 7.90165C4.80161 8.60491 5.75544 9 6.75 9Z"
                        fill="#750005"
                        fillOpacity="0.8"
                      />
                    </svg>
                  )}
                </span>
              </div>
              <p>{item.description}</p>
            </header>
          </li>
        ))}
      </ul>
    </div>
  );
};

const ViewLog = () => {
  const location = useLocation();
  const id = location.pathname.split("/")[3];
  const name = location.pathname.split("/")[4];

  const [logDetails, setLogDetails] = useState(null);
  const [cardMetrics, setCardMetrics] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const userInfo = useSelector((state) => state.auth.authState);
  const [filterBy, setFilterBy] = useState({
    by: "All",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          style={{ fill: "black" }}
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z"
          fill="black"
        />
        <path
          style={{ fill: "black" }}
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H21C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12Z"
          fill="black"
        />
        <path
          style={{ fill: "black" }}
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0378 6.10356C9.4079 7.57435 9 9.65851 9 11.9999C9 14.3413 9.4079 16.4255 10.0378 17.8962C10.3533 18.633 10.7097 19.1812 11.0673 19.5344C11.4217 19.8844 11.736 20.0062 12 20.0062C12.264 20.0062 12.5783 19.8844 12.9327 19.5344C13.2903 19.1812 13.6467 18.633 13.9622 17.8962C14.5921 16.4255 15 14.3413 15 11.9999C15 9.65851 14.5921 7.57435 13.9622 6.10356C13.6467 5.36682 13.2903 4.81856 12.9327 4.46538C12.5783 4.11538 12.264 3.99365 12 3.99365C11.736 3.99365 11.4217 4.11538 11.0673 4.46538C10.7097 4.81856 10.3533 5.36682 10.0378 6.10356ZM10.0133 3.39814C10.5562 2.86196 11.2284 2.49365 12 2.49365C12.7716 2.49365 13.4438 2.86196 13.9867 3.39814C14.5264 3.93115 14.978 4.66521 15.3411 5.51304C16.0684 7.21139 16.5 9.50535 16.5 11.9999C16.5 14.4945 16.0684 16.7884 15.3411 18.4868C14.978 19.3346 14.5264 20.0687 13.9867 20.6017C13.4438 21.1378 12.7716 21.5062 12 21.5062C11.2284 21.5062 10.5562 21.1378 10.0133 20.6017C9.47362 20.0687 9.02201 19.3346 8.65891 18.4868C7.93157 16.7884 7.5 14.4945 7.5 11.9999C7.5 9.50535 7.93157 7.21139 8.65891 5.51304C9.02201 4.66521 9.47362 3.93115 10.0133 3.39814Z"
          fill="black"
        />
      </svg>
    ),
  });
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDate, setOpenDate] = useState(false);
  const [openDuration, setOpenDuration] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [minduration, setMinDuration] = useState(0);
  const [maxduration, setMaxDuration] = useState(0);
  const [filter, setFilter] = useState(null);
  const [openToolTip, setOpenToolTip] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [isExport, setIsExport] = useState(false);
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const th = ["S/N", "Date", "Name", "Duration", "Msisdn", "Cost", "Status"];
  const thsms = ["S/N", "Date", "Name", "Msisdn", "Cost", "Status"];

  useEffect(() => {
    const getLogDetails = async () => {
      setLoading(true);
      try {
        await axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/telemarketing/dev/jobs/summary/${id}`,
            {
              client_id: userInfo.id,
              token: userInfo.token,
            }
          )
          .then((res) => {
            if (res.status === 200) {
              setCardMetrics(res.data);
              setLogDetails(res?.data?.items);
            }
          });
        setLoading(false);
      } catch (error) {
        setNotFound("No Logs Found");
        console.log(error);
      }
    };
    getLogDetails();
  }, [id]);

  const filterData = new FormData();

  filterData.append("client_id", userInfo?.id);
  filterData.append("token", userInfo.token);
  filterData.append("page", currentPage);

  const getLogDetails = async (formData) => {
    setLoading(true);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/telemarketing/dev/jobs/items/${id}`,
          formData
        )
        .then((res) => {
          if (res.status === 200) {
            setLogDetails(res.data);
            console.log(res.data);
          }
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNotFound("No Logs Found");
      console.log(error);
    }
  };

  const handleNextPage = (pageNumber) => {
    setCurrentPage(pageNumber);
    if (filter) {
      if (filterBy) {
        filterData.append("page", pageNumber);
        filterData.append("status", filterBy.toLowerCase());
        getLogDetails(filterData);
      }
    } else {
      filterData.append("page", pageNumber);
      getLogDetails(filterData, pageNumber);
    }
  };

  const handleFilter = (data) => {
    setFilter(true);
    setFilterBy(data);
    setCurrentPage(1);
    if (data.by === "Failed" || data.by === "Success") {
      filterData.append("status", data.by.toLowerCase());
      getLogDetails(filterData);
      setIsOpen(false);
      setOpenDuration(false);
      setOpenDate(false);
    } else if (data.by === "All") {
      getLogDetails(filterData);
      setIsOpen(false);
      setOpenDuration(false);
      setOpenDate(false);
    } else if (data.by === "Date") {
      setOpenDate(!openDate);
      setOpenDuration(false);
    } else {
      setOpenDuration(!openDuration);
      setOpenDate(false);
    }
  };

  const handleStatusFilter = (data) => {
    setStatus(data);
    setFilterBy(data);
    filterData.append("status", data.toLowerCase());
    getLogDetails(filterData);
  };

  const handleOpenDropdown = () => {
    setIsOpen(!isOpen);
    setOpenDate(false);
    setOpenDuration(false);
    setOpenToolTip(false);
  };

  useEffect(() => {
    if (openDuration && minduration && maxduration) {
      filterData.append("min_sec_duration", minduration);
      filterData.append("max_sec_duration", maxduration);
      getLogDetails(filterData);
    }
  }, [minduration, maxduration, openDuration]);

  useEffect(() => {
    if (openDate && startDate && endDate) {
      filterData.append("date_from", dayjs(startDate).format("YYYY-MM-DD"));
      filterData.append("date_to", dayjs(endDate).format("YYYY-MM-DD"));

      getLogDetails(filterData);
    }
  }, [endDate, startDate, openDate]);

  const closeRef = useRef();

  useClickOutside(closeRef, setIsOpen);
  useClickOutside(closeRef, setOpenDuration);
  useClickOutside(closeRef, setIsExport);

  const payload = {
    client_id: userInfo.id,
    token: userInfo.token,
    export: true,
  };

  const payloadWithFilter = {
    client_id: userInfo.id,
    token: userInfo.token,
    export: true,
    status: filter && status?.toLowerCase(),
  };

  const handleExport = async (payload) => {
    setIsLoading(true);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/telemarketing/dev/jobs/items/${id}`,
          payload
        )
        .then((res) => {
          if (res.status === 200) {
            setIsLoading(false);
            setIsExport(true);
            setCsvFile(res.data.items);
          }
        });
    } catch (error) {
      setIsLoading(false);
      setNotFound("No Logs Found");
      console.log(error);
    }
  };

  const exportPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const columns = ["local_cost", "msisdn", "run_time", "status"];
    var rows = [];

    for (let i = 0; i < csvFile.length; i++) {
      /*for (var key in json[i]) {
        var temp = [key, json[i][key]];
        rows.push(temp);
      }*/
      var temp = [
        csvFile[i].local_cost,
        csvFile[i].msisdn,
        csvFile[i].run_time,
        csvFile[i].status,
      ];
      rows.push(temp);
    }

    pdf.text(235, 40, `${name} Job`);
    pdf.autoTable(columns, rows, {
      startY: 65,
      theme: "grid",
      styles: {
        font: "times",
        halign: "center",
        cellPadding: 3.5,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
      },
      headStyles: {
        textColor: [0, 0, 0],
        fontStyle: "normal",
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: [166, 204, 247],
      },
      alternateRowStyles: {
        fillColor: [212, 212, 212],
        textColor: [0, 0, 0],
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      rowStyles: {
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      tableLineColor: [0, 0, 0],
    });

    pdf.save(`${name}_jobs`);
    setIsExport(false);
  };

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: white;
    baground-color: white;
  `;
  return (
    <Layout pageTitle={name}>
      <div style={{ padding: "2rem" }}>
        <a href="/user/analytics">
          {" "}
          <span>
            <svg
              width="20"
              height="16"
              viewBox="0 0 20 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 15L1 8M1 8L8 1M1 8L19 8"
                stroke="#EB2931"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>{" "}
          <span> Back</span>
        </a>
        <Card
          logsMetrics={
            cardMetrics && {
              processed: cardMetrics.totalProcessed
                ? cardMetrics.totalProcessed
                : 0,
              totalCost: cardMetrics?.job?.calculatedCost
                ? cardMetrics?.job?.calculatedCost
                : 0,
              failed: cardMetrics.failed ? cardMetrics.failed : 0,
              successRate: cardMetrics.successRatePercentage
                ? cardMetrics.successRatePercentage
                : 0,
            }
          }
        />
        <div ref={closeRef}>
          {isOpen &&
            (cardMetrics.job.type === "voice" ? (
              <DropDown handleSelect={(item) => handleFilter(item)} />
            ) : (
              <SmsDropDown handleSelect={(item) => handleFilter(item)} />
            ))}

          {openDate && (
            <DateDropDown
              startDate={startDate}
              endDate={endDate}
              handleStartDate={(date) => setStartDate(date)}
              handleEndDate={(date) => setEndDate(date)}
            />
          )}
          {openDuration &&
            (cardMetrics.job.type === "voice" ? (
              <DurationDropDown
                handleMaxDuration={(max) => setMaxDuration(max)}
                handleMinDuration={(min) => setMinDuration(min)}
              />
            ) : (
              <SmsStatus handleClick={(item) => handleStatusFilter(item)} />
            ))}

          {openToolTip && <ToolTip />}
        </div>
        <div className={style["table--top"]}>
          <Button
            onClick={() => handleExport(filter ? payloadWithFilter : payload)}
            className="small--filled"
          >
            {!isLoading ? (
              "Export "
            ) : (
              <ScaleLoader
                css={override}
                size={80}
                color={"#fff"}
                loading={true}
              />
            )}
          </Button>

          <Button
            type="button"
            className="filter--button"
            onClick={handleOpenDropdown}
          >
            <span>
              <svg
                width="14"
                height="12"
                viewBox="0 0 14 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.128568 2.26839L2.31563 0.125478C2.48647 -0.0418526 2.7636 -0.0417991 2.93434 0.125478L5.12132 2.26839C5.39667 2.53812 5.20059 3.00001 4.81195 3.00001H3.5V11.5714C3.5 11.8081 3.30414 12 3.0625 12H2.1875C1.94586 12 1.75 11.8081 1.75 11.5714V3.00001H0.437935C0.0485329 3.00001 -0.146209 2.53758 0.128568 2.26839ZM6.5625 1.7143H13.5625C13.8041 1.7143 14 1.52243 14 1.28573V0.428584C14 0.191879 13.8041 1.34454e-05 13.5625 1.34454e-05H6.5625C6.32086 1.34454e-05 6.125 0.191879 6.125 0.428584V1.28573C6.125 1.52243 6.32086 1.7143 6.5625 1.7143ZM6.125 4.71429V3.85715C6.125 3.62045 6.32086 3.42858 6.5625 3.42858H11.8125C12.0541 3.42858 12.25 3.62045 12.25 3.85715V4.71429C12.25 4.951 12.0541 5.14287 11.8125 5.14287H6.5625C6.32086 5.14287 6.125 4.951 6.125 4.71429ZM6.125 11.5714V10.7143C6.125 10.4776 6.32086 10.2857 6.5625 10.2857H8.3125C8.55414 10.2857 8.75 10.4776 8.75 10.7143V11.5714C8.75 11.8081 8.55414 12 8.3125 12H6.5625C6.32086 12 6.125 11.8081 6.125 11.5714ZM6.125 8.14286V7.28572C6.125 7.04901 6.32086 6.85715 6.5625 6.85715H10.0625C10.3041 6.85715 10.5 7.04901 10.5 7.28572V8.14286C10.5 8.37957 10.3041 8.57143 10.0625 8.57143H6.5625C6.32086 8.57143 6.125 8.37957 6.125 8.14286Z"
                  fill="#BDBDBD"
                />
              </svg>
            </span>
            Filter By {filterBy.by || filterBy}
            <span>{filterBy?.icon}</span>
          </Button>
        </div>

        <div className={style["table--container"]}>
          <table
            id="test"
            style={{
              border: "1px solid rgba(0, 0, 0, 0.4)",
              borderRadius: "50px",
            }}
          >
            <thead>
              <tr>
                {cardMetrics?.job?.type !== "sms"
                  ? th.map((item, index) => {
                      return (
                        <th key={index}>
                          {item}
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => setOpenToolTip(!openToolTip)}
                          >
                            {item.toLowerCase() === "status" ? (
                              <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="info-circle"
                                class="svg-inline--fa fa-info-circle fa-w-16"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                              >
                                <path
                                  style={{ fill: "#fff" }}
                                  fill="currentColor"
                                  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                                ></path>
                              </svg>
                            ) : (
                              ""
                            )}
                          </span>
                        </th>
                      );
                    })
                  : thsms.map((item, index) => {
                      return (
                        <th key={index}>
                          {item}{" "}
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => setOpenToolTip(!openToolTip)}
                          >
                            {item.toLowerCase() === "status" ? (
                              <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="info-circle"
                                class="svg-inline--fa fa-info-circle fa-w-16"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                              >
                                <path
                                  style={{ fill: "#fff" }}
                                  fill="currentColor"
                                  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                                ></path>
                              </svg>
                            ) : (
                              ""
                            )}
                          </span>
                        </th>
                      );
                    })}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <ScaleLoader />
              ) : (
                logDetails &&
                logDetails?.data.map((job, index) => (
                  <tr key={index} className={style["table--body"]}>
                    <td>{index + 1}</td>
                    <td>{job.created_at}</td>
                    <td>{job.name}</td>
                    {cardMetrics.job.type !== "sms" && (
                      <td>{job.duration_in_seconds}s</td>
                    )}
                    <td>{job.msisdn}</td>
                    <td>NGN {job.local_cost}</td>
                    <td>
                      {job.type === "voice" ? (
                        job.jobstatus.toLowerCase() === "success" ? (
                          <span className={style["success"]}>
                            {job.jobstatus}
                          </span>
                        ) : (
                          <span className={style["failed"]}>
                            {job.jobstatus}
                          </span>
                        )
                      ) : job.status.toLowerCase() === "success" ? (
                        <span className={style["success"]}>{job.status}</span>
                      ) : job.status.toLowerCase() === "sent" ? (
                        <span className={style["new"]}>{job.status}</span>
                      ) : (
                        <span className={style["failed"]}>{job.status}</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className={style["pagination--container"]}>
          {notFound || !logDetails ? (
            ""
          ) : (
            <Pagination
              numberOfPages={Math.ceil(logDetails?.total / 15)}
              currentPage={currentPage}
              nextPage={handleNextPage}
            />
          )}
        </div>

        <Dialog isOpen={isExport} onClick={() => setIsExport(false)}>
          <div
            ref={closeRef}
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              width: "350px",
            }}
          >
            <p>Click the button below to download</p>
            {csvFile && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <Button className="small--ghost">
                  <CSVLink
                    style={{
                      textDecoration: "none",
                      color: "#eb2931",
                      textAlign: "center",
                      display: "block",
                    }}
                    data={csvFile}
                    filename={`${name}_jobs`}
                  >
                    CSV
                  </CSVLink>
                </Button>
                <Button className="small--filled" onClick={exportPDF}>
                  PDF
                </Button>
              </div>
            )}
          </div>
        </Dialog>
      </div>
    </Layout>
  );
};

export default ViewLog;
